'use client';

import { useRef, useCallback, RefObject } from 'react';

export interface UseHorizontalScrollOptions {
  scrollFraction?: number;
}

export interface UseHorizontalScrollReturn<T extends HTMLElement> {
  scrollRef: RefObject<T | null>;
  scrollLeft: () => void;
  scrollRight: () => void;
}

export const useHorizontalScroll = <T extends HTMLElement = HTMLElement>(
  options: UseHorizontalScrollOptions = {},
): UseHorizontalScrollReturn<T> => {
  const { scrollFraction = 0.5 } = options;
  const scrollRef = useRef<T | null>(null);

  const scrollLeft = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        behavior: 'smooth',
        left: -scrollRef.current.clientWidth * scrollFraction,
      });
    }
  }, [scrollFraction]);

  const scrollRight = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        behavior: 'smooth',
        left: scrollRef.current.clientWidth * scrollFraction,
      });
    }
  }, [scrollFraction]);

  return {
    scrollLeft,
    scrollRef,
    scrollRight,
  };
};

export default useHorizontalScroll;
